module.exports = __webpack_public_path__ + "images/drawings/moon/new.19bceb888a2a261c6bbfaf675de7d758.png";